import { render, staticRenderFns } from "./RelatorioEditor.vue?vue&type=template&id=23df193c&"
import script from "./RelatorioEditor.vue?vue&type=script&lang=js&"
export * from "./RelatorioEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports